import {
  REFERRALS_FETCH_REQUESTED,
  REFERRALS_FETCHED,
  REFERRALS_FETCH_FAILED,
  REFERRAL_FETCH_REQUESTED,
  REFERRAL_FETCHED,
  REFERRAL_FETCH_FAILED,
  TOGGLE_SPINNER,
  TOGGLE_NOTIFICATION,
} from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';

 const dispatchReferral = (dispatch) => (data) => {
  return dispatch({
    type: REFERRAL_FETCHED,
    data: { referral: data.referral || data }
  });
}

 export const createReferral = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

   return api.createReferral(attrs)
    .then(dispatchReferral(dispatch));
};

 export const updateReferral = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

   return api.updateReferral(attrs)
    .then(dispatchReferral(dispatch));
};

 export const fetchReferral = (id) => (dispatch, getState) => {
  const { api } = getState().app;

   return asyncDispatcher(dispatch, {
    pending: REFERRAL_FETCH_REQUESTED,
    action: api.fetchReferral(id),
    success: REFERRAL_FETCHED,
    failure: REFERRAL_FETCH_FAILED
  });
};

 export const fetchReferrals = () => (dispatch, getState) => {
  const { api } = getState().app;

   return asyncDispatcher(dispatch, {
    pending: REFERRALS_FETCH_REQUESTED,
    action: api.fetchReferrals(),
    success: REFERRALS_FETCHED,
    failure: REFERRALS_FETCH_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/referrals.js